import {NgModule} from '@angular/core'
import { SentenceCasePipe } from './sentencecase.pipe'

@NgModule({
  declarations: [SentenceCasePipe],
  exports: [SentenceCasePipe]
})
export class SentenceCaseModule {}
